module.exports = __webpack_public_path__ + "static/code-master-win-f0e6ed3021735db17e16b8878fff343b.jpg";